/*!
 *  Very Important - Do Not Remove
 *  jQuery UI is being used in the app:
 *  1. Workflows to provide sortable workflows
 *
 * jQuery UI - v1.10.2 - 2013-04-15
 *
 * http://jqueryui.com
 * Includes: jquery.ui.widget.js
 * Copyright 2013 jQuery Foundation and other contributors Licensed MIT
 *
 * http://docs.jquery.com/UI/Widget
 */
;(function (e, t) {
  var i = 0,
    s = Array.prototype.slice,
    n = e.cleanData
  ;(e.cleanData = function (t) {
    for (var i, s = 0; null != (i = t[s]); s++)
      try {
        e(i).triggerHandler('remove')
      } catch (a) {}
    n(t)
  }),
    (e.widget = function (i, s, n) {
      var a,
        r,
        o,
        h,
        l = {},
        u = i.split('.')[0]
      ;(i = i.split('.')[1]),
        (a = u + '-' + i),
        n || ((n = s), (s = e.Widget)),
        (e.expr[':'][a.toLowerCase()] = function (t) {
          return !!e.data(t, a)
        }),
        (e[u] = e[u] || {}),
        (r = e[u][i]),
        (o = e[u][i] =
          function (e, i) {
            return this._createWidget
              ? (arguments.length && this._createWidget(e, i), t)
              : new o(e, i)
          }),
        e.extend(o, r, {
          version: n.version,
          _proto: e.extend({}, n),
          _childConstructors: [],
        }),
        (h = new s()),
        (h.options = e.widget.extend({}, h.options)),
        e.each(n, function (i, n) {
          return e.isFunction(n)
            ? ((l[i] = (function () {
                var e = function () {
                    return s.prototype[i].apply(this, arguments)
                  },
                  t = function (e) {
                    return s.prototype[i].apply(this, e)
                  }
                return function () {
                  var i,
                    s = this._super,
                    a = this._superApply
                  return (
                    (this._super = e),
                    (this._superApply = t),
                    (i = n.apply(this, arguments)),
                    (this._super = s),
                    (this._superApply = a),
                    i
                  )
                }
              })()),
              t)
            : ((l[i] = n), t)
        }),
        (o.prototype = e.widget.extend(
          h,
          { widgetEventPrefix: r ? h.widgetEventPrefix : i },
          l,
          { constructor: o, namespace: u, widgetName: i, widgetFullName: a }
        )),
        r
          ? (e.each(r._childConstructors, function (t, i) {
              var s = i.prototype
              e.widget(s.namespace + '.' + s.widgetName, o, i._proto)
            }),
            delete r._childConstructors)
          : s._childConstructors.push(o),
        e.widget.bridge(i, o)
    }),
    (e.widget.extend = function (i) {
      for (var n, a, r = s.call(arguments, 1), o = 0, h = r.length; h > o; o++)
        for (n in r[o])
          (a = r[o][n]),
            r[o].hasOwnProperty(n) &&
              a !== t &&
              (i[n] = e.isPlainObject(a)
                ? e.isPlainObject(i[n])
                  ? e.widget.extend({}, i[n], a)
                  : e.widget.extend({}, a)
                : a)
      return i
    }),
    (e.widget.bridge = function (i, n) {
      var a = n.prototype.widgetFullName || i
      e.fn[i] = function (r) {
        var o = 'string' == typeof r,
          h = s.call(arguments, 1),
          l = this
        return (
          (r = !o && h.length ? e.widget.extend.apply(null, [r].concat(h)) : r),
          o
            ? this.each(function () {
                var s,
                  n = e.data(this, a)
                return n
                  ? e.isFunction(n[r]) && '_' !== r.charAt(0)
                    ? ((s = n[r].apply(n, h)),
                      s !== n && s !== t
                        ? ((l = s && s.jquery ? l.pushStack(s.get()) : s), !1)
                        : t)
                    : e.error(
                        "no such method '" +
                          r +
                          "' for " +
                          i +
                          ' widget instance'
                      )
                  : e.error(
                      'cannot call methods on ' +
                        i +
                        ' prior to initialization; ' +
                        "attempted to call method '" +
                        r +
                        "'"
                    )
              })
            : this.each(function () {
                var t = e.data(this, a)
                t ? t.option(r || {})._init() : e.data(this, a, new n(r, this))
              }),
          l
        )
      }
    }),
    (e.Widget = function () {}),
    (e.Widget._childConstructors = []),
    (e.Widget.prototype = {
      widgetName: 'widget',
      widgetEventPrefix: '',
      defaultElement: '<div>',
      options: { disabled: !1, create: null },
      _createWidget: function (t, s) {
        ;(s = e(s || this.defaultElement || this)[0]),
          (this.element = e(s)),
          (this.uuid = i++),
          (this.eventNamespace = '.' + this.widgetName + this.uuid),
          (this.options = e.widget.extend(
            {},
            this.options,
            this._getCreateOptions(),
            t
          )),
          (this.bindings = e()),
          (this.hoverable = e()),
          (this.focusable = e()),
          s !== this &&
            (e.data(s, this.widgetFullName, this),
            this._on(!0, this.element, {
              remove: function (e) {
                e.target === s && this.destroy()
              },
            }),
            (this.document = e(s.style ? s.ownerDocument : s.document || s)),
            (this.window = e(
              this.document[0].defaultView || this.document[0].parentWindow
            ))),
          this._create(),
          this._trigger('create', null, this._getCreateEventData()),
          this._init()
      },
      _getCreateOptions: e.noop,
      _getCreateEventData: e.noop,
      _create: e.noop,
      _init: e.noop,
      destroy: function () {
        this._destroy(),
          this.element
            .unbind(this.eventNamespace)
            .removeData(this.widgetName)
            .removeData(this.widgetFullName)
            .removeData(e.camelCase(this.widgetFullName)),
          this.widget()
            .unbind(this.eventNamespace)
            .removeAttr('aria-disabled')
            .removeClass(
              this.widgetFullName + '-disabled ' + 'ui-state-disabled'
            ),
          this.bindings.unbind(this.eventNamespace),
          this.hoverable.removeClass('ui-state-hover'),
          this.focusable.removeClass('ui-state-focus')
      },
      _destroy: e.noop,
      widget: function () {
        return this.element
      },
      option: function (i, s) {
        var n,
          a,
          r,
          o = i
        if (0 === arguments.length) return e.widget.extend({}, this.options)
        if ('string' == typeof i)
          if (((o = {}), (n = i.split('.')), (i = n.shift()), n.length)) {
            for (
              a = o[i] = e.widget.extend({}, this.options[i]), r = 0;
              n.length - 1 > r;
              r++
            )
              (a[n[r]] = a[n[r]] || {}), (a = a[n[r]])
            if (((i = n.pop()), s === t)) return a[i] === t ? null : a[i]
            a[i] = s
          } else {
            if (s === t) return this.options[i] === t ? null : this.options[i]
            o[i] = s
          }
        return this._setOptions(o), this
      },
      _setOptions: function (e) {
        var t
        for (t in e) this._setOption(t, e[t])
        return this
      },
      _setOption: function (e, t) {
        return (
          (this.options[e] = t),
          'disabled' === e &&
            (this.widget()
              .toggleClass(
                this.widgetFullName + '-disabled ui-state-disabled',
                !!t
              )
              .attr('aria-disabled', t),
            this.hoverable.removeClass('ui-state-hover'),
            this.focusable.removeClass('ui-state-focus')),
          this
        )
      },
      enable: function () {
        return this._setOption('disabled', !1)
      },
      disable: function () {
        return this._setOption('disabled', !0)
      },
      _on: function (i, s, n) {
        var a,
          r = this
        'boolean' != typeof i && ((n = s), (s = i), (i = !1)),
          n
            ? ((s = a = e(s)), (this.bindings = this.bindings.add(s)))
            : ((n = s), (s = this.element), (a = this.widget())),
          e.each(n, function (n, o) {
            function h() {
              return i ||
                (r.options.disabled !== !0 &&
                  !e(this).hasClass('ui-state-disabled'))
                ? ('string' == typeof o ? r[o] : o).apply(r, arguments)
                : t
            }
            'string' != typeof o &&
              (h.guid = o.guid = o.guid || h.guid || e.guid++)
            var l = n.match(/^(\w+)\s*(.*)$/),
              u = l[1] + r.eventNamespace,
              c = l[2]
            c ? a.delegate(c, u, h) : s.bind(u, h)
          })
      },
      _off: function (e, t) {
        ;(t =
          (t || '').split(' ').join(this.eventNamespace + ' ') +
          this.eventNamespace),
          e.unbind(t).undelegate(t)
      },
      _delay: function (e, t) {
        function i() {
          return ('string' == typeof e ? s[e] : e).apply(s, arguments)
        }
        var s = this
        return setTimeout(i, t || 0)
      },
      _hoverable: function (t) {
        ;(this.hoverable = this.hoverable.add(t)),
          this._on(t, {
            mouseenter: function (t) {
              e(t.currentTarget).addClass('ui-state-hover')
            },
            mouseleave: function (t) {
              e(t.currentTarget).removeClass('ui-state-hover')
            },
          })
      },
      _focusable: function (t) {
        ;(this.focusable = this.focusable.add(t)),
          this._on(t, {
            focusin: function (t) {
              e(t.currentTarget).addClass('ui-state-focus')
            },
            focusout: function (t) {
              e(t.currentTarget).removeClass('ui-state-focus')
            },
          })
      },
      _trigger: function (t, i, s) {
        var n,
          a,
          r = this.options[t]
        if (
          ((s = s || {}),
          (i = e.Event(i)),
          (i.type = (
            t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t
          ).toLowerCase()),
          (i.target = this.element[0]),
          (a = i.originalEvent))
        )
          for (n in a) n in i || (i[n] = a[n])
        return (
          this.element.trigger(i, s),
          !(
            (e.isFunction(r) &&
              r.apply(this.element[0], [i].concat(s)) === !1) ||
            i.isDefaultPrevented()
          )
        )
      },
    }),
    e.each({ show: 'fadeIn', hide: 'fadeOut' }, function (t, i) {
      e.Widget.prototype['_' + t] = function (s, n, a) {
        'string' == typeof n && (n = { effect: n })
        var r,
          o = n ? (n === !0 || 'number' == typeof n ? i : n.effect || i) : t
        ;(n = n || {}),
          'number' == typeof n && (n = { duration: n }),
          (r = !e.isEmptyObject(n)),
          (n.complete = a),
          n.delay && s.delay(n.delay),
          r && e.effects && e.effects.effect[o]
            ? s[t](n)
            : o !== t && s[o]
            ? s[o](n.duration, n.easing, a)
            : s.queue(function (i) {
                e(this)[t](), a && a.call(s[0]), i()
              })
      }
    })
})(jQuery)
/*!
 * jQuery UI - v1.10.2 - 2013-04-15
 *
 * http://jqueryui.com
 * Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.sortable.js, jquery.ui.draggable.js (draggable added 9/20/2013 by bjones to replace dragbit)
 *
 * Copyright 2013 jQuery Foundation and other contributors Licensed MIT
 *
 *  Contains:
 *      Core        - jQuery UI Lib - Used for everything
 *      Mouse       - jQuery UI Lib - Also very common
 *      Sortable    - jQuery UI Lib
 *
 *      These 2 extras are used often so other jQuery UI Libs wont be a burden.
 */
;(function (c, l) {
  function a(a, d) {
    var e, f
    e = a.nodeName.toLowerCase()
    if ('area' === e) {
      e = a.parentNode
      f = e.name
      if (!a.href || !f || 'map' !== e.nodeName.toLowerCase()) return !1
      e = c('img[usemap=#' + f + ']')[0]
      return !!e && b(e)
    }
    return (
      (/input|select|textarea|button|object/.test(e)
        ? !a.disabled
        : 'a' === e
        ? a.href || d
        : d) && b(a)
    )
  }
  function b(a) {
    return (
      c.expr.filters.visible(a) &&
      !c(a)
        .parents()
        .addBack()
        .filter(function () {
          return 'hidden' === c.css(this, 'visibility')
        }).length
    )
  }
  var d = 0,
    e = /^ui-id-\d+$/
  c.ui = c.ui || {}
  c.extend(c.ui, {
    version: '1.10.2',
    keyCode: {
      BACKSPACE: 8,
      COMMA: 188,
      DELETE: 46,
      DOWN: 40,
      END: 35,
      ENTER: 13,
      ESCAPE: 27,
      HOME: 36,
      LEFT: 37,
      NUMPAD_ADD: 107,
      NUMPAD_DECIMAL: 110,
      NUMPAD_DIVIDE: 111,
      NUMPAD_ENTER: 108,
      NUMPAD_MULTIPLY: 106,
      NUMPAD_SUBTRACT: 109,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      PERIOD: 190,
      RIGHT: 39,
      SPACE: 32,
      TAB: 9,
      UP: 38,
    },
  })
  c.fn.extend({
    focus: (function (a) {
      return function (b, d) {
        return 'number' === typeof b
          ? this.each(function () {
              var a = this
              setTimeout(function () {
                c(a).focus()
                d && d.call(a)
              }, b)
            })
          : a.apply(this, arguments)
      }
    })(c.fn.focus),
    scrollParent: function () {
      var a
      a =
        (c.ui.ie && /(static|relative)/.test(this.css('position'))) ||
        /absolute/.test(this.css('position'))
          ? this.parents()
              .filter(function () {
                return (
                  /(relative|absolute|fixed)/.test(c.css(this, 'position')) &&
                  /(auto|scroll)/.test(
                    c.css(this, 'overflow') +
                      c.css(this, 'overflow-y') +
                      c.css(this, 'overflow-x')
                  )
                )
              })
              .eq(0)
          : this.parents()
              .filter(function () {
                return /(auto|scroll)/.test(
                  c.css(this, 'overflow') +
                    c.css(this, 'overflow-y') +
                    c.css(this, 'overflow-x')
                )
              })
              .eq(0)
      return /fixed/.test(this.css('position')) || !a.length ? c(document) : a
    },
    zIndex: function (a) {
      if (a !== l) return this.css('zIndex', a)
      if (this.length) {
        a = c(this[0])
        for (var b; a.length && a[0] !== document; ) {
          b = a.css('position')
          if ('absolute' === b || 'relative' === b || 'fixed' === b)
            if (((b = parseInt(a.css('zIndex'), 10)), !isNaN(b) && 0 !== b))
              return b
          a = a.parent()
        }
      }
      return 0
    },
    uniqueId: function () {
      return this.each(function () {
        this.id || (this.id = 'ui-id-' + ++d)
      })
    },
    removeUniqueId: function () {
      return this.each(function () {
        e.test(this.id) && c(this).removeAttr('id')
      })
    },
  })
  c.extend(c.expr[':'], {
    data: c.expr.createPseudo
      ? c.expr.createPseudo(function (a) {
          return function (b) {
            return !!c.data(b, a)
          }
        })
      : function (a, b, d) {
          return !!c.data(a, d[3])
        },
    focusable: function (b) {
      return a(b, !isNaN(c.attr(b, 'tabindex')))
    },
    tabbable: function (b) {
      var d = c.attr(b, 'tabindex'),
        e = isNaN(d)
      return (e || 0 <= d) && a(b, !e)
    },
  })
  c('<a>').outerWidth(1).jquery ||
    c.each(['Width', 'Height'], function (a, b) {
      function d(a, b, f, g) {
        c.each(e, function () {
          b -= parseFloat(c.css(a, 'padding' + this)) || 0
          f && (b -= parseFloat(c.css(a, 'border' + this + 'Width')) || 0)
          g && (b -= parseFloat(c.css(a, 'margin' + this)) || 0)
        })
        return b
      }
      var e = 'Width' === b ? ['Left', 'Right'] : ['Top', 'Bottom'],
        f = b.toLowerCase(),
        h = {
          innerWidth: c.fn.innerWidth,
          innerHeight: c.fn.innerHeight,
          outerWidth: c.fn.outerWidth,
          outerHeight: c.fn.outerHeight,
        }
      c.fn['inner' + b] = function (a) {
        return a === l
          ? h['inner' + b].call(this)
          : this.each(function () {
              c(this).css(f, d(this, a) + 'px')
            })
      }
      c.fn['outer' + b] = function (a, e) {
        return 'number' !== typeof a
          ? h['outer' + b].call(this, a)
          : this.each(function () {
              c(this).css(f, d(this, a, !0, e) + 'px')
            })
      }
    })
  c.fn.addBack ||
    (c.fn.addBack = function (a) {
      return this.add(null == a ? this.prevObject : this.prevObject.filter(a))
    })
  if (c('<a>').data('a-b', 'a').removeData('a-b').data('a-b')) {
    var f = c.fn.removeData
    c.fn.removeData = function (a) {
      return arguments.length ? f.call(this, c.camelCase(a)) : f.call(this)
    }
  }
  c.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase())
  c.support.selectstart = 'onselectstart' in document.createElement('div')
  c.fn.extend({
    disableSelection: function () {
      return this.bind(
        (c.support.selectstart ? 'selectstart' : 'mousedown') +
          '.ui-disableSelection',
        function (a) {
          a.preventDefault()
        }
      )
    },
    enableSelection: function () {
      return this.unbind('.ui-disableSelection')
    },
  })
  c.extend(c.ui, {
    plugin: {
      add: function (a, b, d) {
        var e
        a = c.ui[a].prototype
        for (e in d)
          (a.plugins[e] = a.plugins[e] || []), a.plugins[e].push([b, d[e]])
      },
      call: function (a, b, d) {
        var c = a.plugins[b]
        if (
          c &&
          a.element[0].parentNode &&
          11 !== a.element[0].parentNode.nodeType
        )
          for (b = 0; b < c.length; b++)
            a.options[c[b][0]] && c[b][1].apply(a.element, d)
      },
    },
    hasScroll: function (a, b) {
      if ('hidden' === c(a).css('overflow')) return !1
      var d = b && 'left' === b ? 'scrollLeft' : 'scrollTop',
        e = !1
      if (0 < a[d]) return !0
      a[d] = 1
      e = 0 < a[d]
      a[d] = 0
      return e
    },
  })
})(jQuery)
;(function (c) {
  var l = !1
  c(document).mouseup(function () {
    l = !1
  })
  c.widget('ui.mouse', {
    version: '1.10.2',
    options: {
      cancel: 'input,textarea,button,select,option',
      distance: 1,
      delay: 0,
    },
    _mouseInit: function () {
      var a = this
      this.element
        .bind('mousedown.' + this.widgetName, function (b) {
          return a._mouseDown(b)
        })
        .bind('click.' + this.widgetName, function (b) {
          if (!0 === c.data(b.target, a.widgetName + '.preventClickEvent'))
            return (
              c.removeData(b.target, a.widgetName + '.preventClickEvent'),
              b.stopImmediatePropagation(),
              !1
            )
        })
      this.started = !1
    },
    _mouseDestroy: function () {
      this.element.unbind('.' + this.widgetName)
      this._mouseMoveDelegate &&
        c(document)
          .unbind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
          .unbind('mouseup.' + this.widgetName, this._mouseUpDelegate)
    },
    _mouseDown: function (a) {
      if (!l) {
        this._mouseStarted && this._mouseUp(a)
        this._mouseDownEvent = a
        var b = this,
          d = 1 === a.which,
          e =
            'string' === typeof this.options.cancel && a.target.nodeName
              ? c(a.target).closest(this.options.cancel).length
              : !1
        if (!d || e || !this._mouseCapture(a)) return !0
        this.mouseDelayMet = !this.options.delay
        this.mouseDelayMet ||
          (this._mouseDelayTimer = setTimeout(function () {
            b.mouseDelayMet = !0
          }, this.options.delay))
        if (
          this._mouseDistanceMet(a) &&
          this._mouseDelayMet(a) &&
          ((this._mouseStarted = !1 !== this._mouseStart(a)),
          !this._mouseStarted)
        )
          return a.preventDefault(), !0
        !0 === c.data(a.target, this.widgetName + '.preventClickEvent') &&
          c.removeData(a.target, this.widgetName + '.preventClickEvent')
        this._mouseMoveDelegate = function (a) {
          return b._mouseMove(a)
        }
        this._mouseUpDelegate = function (a) {
          return b._mouseUp(a)
        }
        c(document)
          .bind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
          .bind('mouseup.' + this.widgetName, this._mouseUpDelegate)
        a.preventDefault()
        return (l = !0)
      }
    },
    _mouseMove: function (a) {
      if (
        c.ui.ie &&
        (!document.documentMode || 9 > document.documentMode) &&
        !a.button
      )
        return this._mouseUp(a)
      if (this._mouseStarted) return this._mouseDrag(a), a.preventDefault()
      this._mouseDistanceMet(a) &&
        this._mouseDelayMet(a) &&
        ((this._mouseStarted = !1 !== this._mouseStart(this._mouseDownEvent, a))
          ? this._mouseDrag(a)
          : this._mouseUp(a))
      return !this._mouseStarted
    },
    _mouseUp: function (a) {
      c(document)
        .unbind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
        .unbind('mouseup.' + this.widgetName, this._mouseUpDelegate)
      this._mouseStarted &&
        ((this._mouseStarted = !1),
        a.target === this._mouseDownEvent.target &&
          c.data(a.target, this.widgetName + '.preventClickEvent', !0),
        this._mouseStop(a))
      return !1
    },
    _mouseDistanceMet: function (a) {
      return (
        Math.max(
          Math.abs(this._mouseDownEvent.pageX - a.pageX),
          Math.abs(this._mouseDownEvent.pageY - a.pageY)
        ) >= this.options.distance
      )
    },
    _mouseDelayMet: function () {
      return this.mouseDelayMet
    },
    _mouseStart: function () {},
    _mouseDrag: function () {},
    _mouseStop: function () {},
    _mouseCapture: function () {
      return !0
    },
  })
})(jQuery)
;(function (c) {
  function l(a) {
    return (
      /left|right/.test(a.css('float')) ||
      /inline|table-cell/.test(a.css('display'))
    )
  }
  c.widget('ui.sortable', c.ui.mouse, {
    version: '1.10.2',
    widgetEventPrefix: 'sort',
    ready: !1,
    options: {
      appendTo: 'parent',
      axis: !1,
      connectWith: !1,
      containment: !1,
      cursor: 'auto',
      cursorAt: !1,
      dropOnEmpty: !0,
      forcePlaceholderSize: !1,
      forceHelperSize: !1,
      grid: !1,
      handle: !1,
      helper: 'original',
      items: '> *',
      opacity: !1,
      placeholder: !1,
      revert: !1,
      scroll: !0,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      scope: 'default',
      tolerance: 'intersect',
      zIndex: 1e3,
      activate: null,
      beforeStop: null,
      change: null,
      deactivate: null,
      out: null,
      over: null,
      receive: null,
      remove: null,
      sort: null,
      start: null,
      stop: null,
      update: null,
    },
    _create: function () {
      var a = this.options
      this.containerCache = {}
      this.element.addClass('ui-sortable')
      this.refresh()
      this.floating = this.items.length
        ? 'x' === a.axis || l(this.items[0].item)
        : !1
      this.offset = this.element.offset()
      this._mouseInit()
      this.ready = !0
    },
    _destroy: function () {
      this.element.removeClass('ui-sortable ui-sortable-disabled')
      this._mouseDestroy()
      for (var a = this.items.length - 1; 0 <= a; a--)
        this.items[a].item.removeData(this.widgetName + '-item')
      return this
    },
    _setOption: function (a, b) {
      'disabled' === a
        ? ((this.options[a] = b),
          this.widget().toggleClass('ui-sortable-disabled', !!b))
        : c.Widget.prototype._setOption.apply(this, arguments)
    },
    _mouseCapture: function (a, b) {
      var d = null,
        e = !1,
        f = this
      if (
        this.reverting ||
        this.options.disabled ||
        'static' === this.options.type
      )
        return !1
      this._refreshItems(a)
      c(a.target)
        .parents()
        .each(function () {
          if (c.data(this, f.widgetName + '-item') === f)
            return (d = c(this)), !1
        })
      c.data(a.target, f.widgetName + '-item') === f && (d = c(a.target))
      if (
        !d ||
        (this.options.handle &&
          !b &&
          (c(this.options.handle, d)
            .find('*')
            .addBack()
            .each(function () {
              this === a.target && (e = !0)
            }),
          !e))
      )
        return !1
      this.currentItem = d
      this._removeCurrentsFromItems()
      return !0
    },
    _mouseStart: function (a, b, d) {
      var e
      b = this.options
      this.currentContainer = this
      this.refreshPositions()
      this.helper = this._createHelper(a)
      this._cacheHelperProportions()
      this._cacheMargins()
      this.scrollParent = this.helper.scrollParent()
      this.offset = this.currentItem.offset()
      this.offset = {
        top: this.offset.top - this.margins.top,
        left: this.offset.left - this.margins.left,
      }
      c.extend(this.offset, {
        click: {
          left: a.pageX - this.offset.left,
          top: a.pageY - this.offset.top,
        },
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset(),
      })
      this.helper.css('position', 'absolute')
      this.cssPosition = this.helper.css('position')
      this.originalPosition = this._generatePosition(a)
      this.originalPageX = a.pageX
      this.originalPageY = a.pageY
      b.cursorAt && this._adjustOffsetFromHelper(b.cursorAt)
      this.domPosition = {
        prev: this.currentItem.prev()[0],
        parent: this.currentItem.parent()[0],
      }
      this.helper[0] !== this.currentItem[0] && this.currentItem.hide()
      this._createPlaceholder()
      b.containment && this._setContainment()
      b.cursor &&
        'auto' !== b.cursor &&
        ((e = this.document.find('body')),
        (this.storedCursor = e.css('cursor')),
        e.css('cursor', b.cursor),
        (this.storedStylesheet = c(
          '<style>*{ cursor: ' + b.cursor + ' !important; }</style>'
        ).appendTo(e)))
      b.opacity &&
        (this.helper.css('opacity') &&
          (this._storedOpacity = this.helper.css('opacity')),
        this.helper.css('opacity', b.opacity))
      b.zIndex &&
        (this.helper.css('zIndex') &&
          (this._storedZIndex = this.helper.css('zIndex')),
        this.helper.css('zIndex', b.zIndex))
      this.scrollParent[0] !== document &&
        'HTML' !== this.scrollParent[0].tagName &&
        (this.overflowOffset = this.scrollParent.offset())
      this._trigger('start', a, this._uiHash())
      this._preserveHelperProportions || this._cacheHelperProportions()
      if (!d)
        for (d = this.containers.length - 1; 0 <= d; d--)
          this.containers[d]._trigger('activate', a, this._uiHash(this))
      c.ui.ddmanager && (c.ui.ddmanager.current = this)
      c.ui.ddmanager &&
        !b.dropBehaviour &&
        c.ui.ddmanager.prepareOffsets(this, a)
      this.dragging = !0
      this.helper.addClass('ui-sortable-helper')
      this._mouseDrag(a)
      return !0
    },
    _mouseDrag: function (a) {
      var b, d, e, f
      b = this.options
      d = !1
      this.position = this._generatePosition(a)
      this.positionAbs = this._convertPositionTo('absolute')
      this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs)
      this.options.scroll &&
        (this.scrollParent[0] !== document &&
        'HTML' !== this.scrollParent[0].tagName
          ? (this.overflowOffset.top +
              this.scrollParent[0].offsetHeight -
              a.pageY <
            b.scrollSensitivity
              ? (this.scrollParent[0].scrollTop = d =
                  this.scrollParent[0].scrollTop + b.scrollSpeed)
              : a.pageY - this.overflowOffset.top < b.scrollSensitivity &&
                (this.scrollParent[0].scrollTop = d =
                  this.scrollParent[0].scrollTop - b.scrollSpeed),
            this.overflowOffset.left +
              this.scrollParent[0].offsetWidth -
              a.pageX <
            b.scrollSensitivity
              ? (this.scrollParent[0].scrollLeft = d =
                  this.scrollParent[0].scrollLeft + b.scrollSpeed)
              : a.pageX - this.overflowOffset.left < b.scrollSensitivity &&
                (this.scrollParent[0].scrollLeft = d =
                  this.scrollParent[0].scrollLeft - b.scrollSpeed))
          : (a.pageY - c(document).scrollTop() < b.scrollSensitivity
              ? (d = c(document).scrollTop(
                  c(document).scrollTop() - b.scrollSpeed
                ))
              : c(window).height() - (a.pageY - c(document).scrollTop()) <
                  b.scrollSensitivity &&
                (d = c(document).scrollTop(
                  c(document).scrollTop() + b.scrollSpeed
                )),
            a.pageX - c(document).scrollLeft() < b.scrollSensitivity
              ? (d = c(document).scrollLeft(
                  c(document).scrollLeft() - b.scrollSpeed
                ))
              : c(window).width() - (a.pageX - c(document).scrollLeft()) <
                  b.scrollSensitivity &&
                (d = c(document).scrollLeft(
                  c(document).scrollLeft() + b.scrollSpeed
                ))),
        !1 !== d &&
          c.ui.ddmanager &&
          !b.dropBehaviour &&
          c.ui.ddmanager.prepareOffsets(this, a))
      this.positionAbs = this._convertPositionTo('absolute')
      if (!this.options.axis || 'y' !== this.options.axis)
        this.helper[0].style.left = this.position.left + 'px'
      if (!this.options.axis || 'x' !== this.options.axis)
        this.helper[0].style.top = this.position.top + 'px'
      for (b = this.items.length - 1; 0 <= b; b--)
        if (
          ((d = this.items[b]),
          (e = d.item[0]),
          (f = this._intersectsWithPointer(d)) &&
            d.instance === this.currentContainer &&
            e !== this.currentItem[0] &&
            this.placeholder[1 === f ? 'next' : 'prev']()[0] !== e &&
            !c.contains(this.placeholder[0], e) &&
            ('semi-dynamic' === this.options.type
              ? !c.contains(this.element[0], e)
              : 1))
        ) {
          this.direction = 1 === f ? 'down' : 'up'
          if (
            'pointer' === this.options.tolerance ||
            this._intersectsWithSides(d)
          )
            this._rearrange(a, d)
          else break
          this._trigger('change', a, this._uiHash())
          break
        }
      this._contactContainers(a)
      c.ui.ddmanager && c.ui.ddmanager.drag(this, a)
      this._trigger('sort', a, this._uiHash())
      this.lastPositionAbs = this.positionAbs
      return !1
    },
    _mouseStop: function (a, b) {
      if (a) {
        c.ui.ddmanager &&
          !this.options.dropBehaviour &&
          c.ui.ddmanager.drop(this, a)
        if (this.options.revert) {
          var d = this,
            e = this.placeholder.offset(),
            f = this.options.axis,
            g = {}
          if (!f || 'x' === f)
            g.left =
              e.left -
              this.offset.parent.left -
              this.margins.left +
              (this.offsetParent[0] === document.body
                ? 0
                : this.offsetParent[0].scrollLeft)
          if (!f || 'y' === f)
            g.top =
              e.top -
              this.offset.parent.top -
              this.margins.top +
              (this.offsetParent[0] === document.body
                ? 0
                : this.offsetParent[0].scrollTop)
          this.reverting = !0
          c(this.helper).animate(
            g,
            parseInt(this.options.revert, 10) || 500,
            function () {
              d._clear(a)
            }
          )
        } else this._clear(a, b)
        return !1
      }
    },
    cancel: function () {
      if (this.dragging) {
        this._mouseUp({ target: null })
        'original' === this.options.helper
          ? this.currentItem
              .css(this._storedCSS)
              .removeClass('ui-sortable-helper')
          : this.currentItem.show()
        for (var a = this.containers.length - 1; 0 <= a; a--)
          this.containers[a]._trigger('deactivate', null, this._uiHash(this)),
            this.containers[a].containerCache.over &&
              (this.containers[a]._trigger('out', null, this._uiHash(this)),
              (this.containers[a].containerCache.over = 0))
      }
      this.placeholder &&
        (this.placeholder[0].parentNode &&
          this.placeholder[0].parentNode.removeChild(this.placeholder[0]),
        'original' !== this.options.helper &&
          this.helper &&
          this.helper[0].parentNode &&
          this.helper.remove(),
        c.extend(this, {
          helper: null,
          dragging: !1,
          reverting: !1,
          _noFinalSort: null,
        }),
        this.domPosition.prev
          ? c(this.domPosition.prev).after(this.currentItem)
          : c(this.domPosition.parent).prepend(this.currentItem))
      return this
    },
    serialize: function (a) {
      var b = this._getItemsAsjQuery(a && a.connected),
        d = []
      a = a || {}
      c(b).each(function () {
        var b = (c(a.item || this).attr(a.attribute || 'id') || '').match(
          a.expression || /(.+)[\-=_](.+)/
        )
        b &&
          d.push(
            (a.key || b[1] + '[]') + '=' + (a.key && a.expression ? b[1] : b[2])
          )
      })
      !d.length && a.key && d.push(a.key + '=')
      return d.join('&')
    },
    toArray: function (a) {
      var b = this._getItemsAsjQuery(a && a.connected),
        d = []
      a = a || {}
      b.each(function () {
        d.push(c(a.item || this).attr(a.attribute || 'id') || '')
      })
      return d
    },
    _intersectsWith: function (a) {
      var b = this.positionAbs.left,
        d = b + this.helperProportions.width,
        c = this.positionAbs.top,
        f = c + this.helperProportions.height,
        g = a.left,
        k = g + a.width,
        j = a.top,
        l = j + a.height,
        m = this.offset.click.top,
        h = this.offset.click.left
      return 'pointer' === this.options.tolerance ||
        this.options.forcePointerForContainers ||
        ('pointer' !== this.options.tolerance &&
          this.helperProportions[this.floating ? 'width' : 'height'] >
            a[this.floating ? 'width' : 'height'])
        ? c + m > j && c + m < l && b + h > g && b + h < k
        : g < b + this.helperProportions.width / 2 &&
            d - this.helperProportions.width / 2 < k &&
            j < c + this.helperProportions.height / 2 &&
            f - this.helperProportions.height / 2 < l
    },
    _intersectsWithPointer: function (a) {
      var b =
        'y' === this.options.axis ||
        (this.positionAbs.left + this.offset.click.left > a.left &&
          this.positionAbs.left + this.offset.click.left < a.left + a.width)
      a =
        ('x' === this.options.axis ||
          (this.positionAbs.top + this.offset.click.top > a.top &&
            this.positionAbs.top + this.offset.click.top < a.top + a.height)) &&
        b
      var b = this._getDragVerticalDirection(),
        d = this._getDragHorizontalDirection()
      return !a
        ? !1
        : this.floating
        ? (d && 'right' === d) || 'down' === b
          ? 2
          : 1
        : b && ('down' === b ? 2 : 1)
    },
    _intersectsWithSides: function (a) {
      var b =
        this.positionAbs.top + this.offset.click.top > a.top + a.height / 2 &&
        this.positionAbs.top + this.offset.click.top <
          a.top + a.height / 2 + a.height
      a =
        this.positionAbs.left + this.offset.click.left > a.left + a.width / 2 &&
        this.positionAbs.left + this.offset.click.left <
          a.left + a.width / 2 + a.width
      var d = this._getDragVerticalDirection(),
        c = this._getDragHorizontalDirection()
      return this.floating && c
        ? ('right' === c && a) || ('left' === c && !a)
        : d && (('down' === d && b) || ('up' === d && !b))
    },
    _getDragVerticalDirection: function () {
      var a = this.positionAbs.top - this.lastPositionAbs.top
      return 0 !== a && (0 < a ? 'down' : 'up')
    },
    _getDragHorizontalDirection: function () {
      var a = this.positionAbs.left - this.lastPositionAbs.left
      return 0 !== a && (0 < a ? 'right' : 'left')
    },
    refresh: function (a) {
      this._refreshItems(a)
      this.refreshPositions()
      return this
    },
    _connectWith: function () {
      var a = this.options
      return a.connectWith.constructor === String
        ? [a.connectWith]
        : a.connectWith
    },
    _getItemsAsjQuery: function (a) {
      var b,
        d,
        e,
        f = [],
        g = [],
        k = this._connectWith()
      if (k && a)
        for (a = k.length - 1; 0 <= a; a--) {
          d = c(k[a])
          for (b = d.length - 1; 0 <= b; b--)
            (e = c.data(d[b], this.widgetFullName)) &&
              e !== this &&
              !e.options.disabled &&
              g.push([
                c.isFunction(e.options.items)
                  ? e.options.items.call(e.element)
                  : c(e.options.items, e.element)
                      .not('.ui-sortable-helper')
                      .not('.ui-sortable-placeholder'),
                e,
              ])
        }
      g.push([
        c.isFunction(this.options.items)
          ? this.options.items.call(this.element, null, {
              options: this.options,
              item: this.currentItem,
            })
          : c(this.options.items, this.element)
              .not('.ui-sortable-helper')
              .not('.ui-sortable-placeholder'),
        this,
      ])
      for (a = g.length - 1; 0 <= a; a--)
        g[a][0].each(function () {
          f.push(this)
        })
      return c(f)
    },
    _removeCurrentsFromItems: function () {
      var a = this.currentItem.find(':data(' + this.widgetName + '-item)')
      this.items = c.grep(this.items, function (b) {
        for (var d = 0; d < a.length; d++) if (a[d] === b.item[0]) return !1
        return !0
      })
    },
    _refreshItems: function (a) {
      this.items = []
      this.containers = [this]
      var b,
        d,
        e,
        f,
        g,
        k = this.items,
        j = [
          [
            c.isFunction(this.options.items)
              ? this.options.items.call(this.element[0], a, {
                  item: this.currentItem,
                })
              : c(this.options.items, this.element),
            this,
          ],
        ]
      if ((g = this._connectWith()) && this.ready)
        for (b = g.length - 1; 0 <= b; b--) {
          e = c(g[b])
          for (d = e.length - 1; 0 <= d; d--)
            if (
              (f = c.data(e[d], this.widgetFullName)) &&
              f !== this &&
              !f.options.disabled
            )
              j.push([
                c.isFunction(f.options.items)
                  ? f.options.items.call(f.element[0], a, {
                      item: this.currentItem,
                    })
                  : c(f.options.items, f.element),
                f,
              ]),
                this.containers.push(f)
        }
      for (b = j.length - 1; 0 <= b; b--) {
        a = j[b][1]
        e = j[b][0]
        d = 0
        for (g = e.length; d < g; d++)
          (f = c(e[d])),
            f.data(this.widgetName + '-item', a),
            k.push({
              item: f,
              instance: a,
              width: 0,
              height: 0,
              left: 0,
              top: 0,
            })
      }
    },
    refreshPositions: function (a) {
      this.offsetParent &&
        this.helper &&
        (this.offset.parent = this._getParentOffset())
      var b, d, e
      for (b = this.items.length - 1; 0 <= b; b--)
        (d = this.items[b]),
          (d.instance !== this.currentContainer &&
            this.currentContainer &&
            d.item[0] !== this.currentItem[0]) ||
            ((e = this.options.toleranceElement
              ? c(this.options.toleranceElement, d.item)
              : d.item),
            a || ((d.width = e.outerWidth()), (d.height = e.outerHeight())),
            (e = e.offset()),
            (d.left = e.left),
            (d.top = e.top))
      if (this.options.custom && this.options.custom.refreshContainers)
        this.options.custom.refreshContainers.call(this)
      else
        for (b = this.containers.length - 1; 0 <= b; b--)
          (e = this.containers[b].element.offset()),
            (this.containers[b].containerCache.left = e.left),
            (this.containers[b].containerCache.top = e.top),
            (this.containers[b].containerCache.width =
              this.containers[b].element.outerWidth()),
            (this.containers[b].containerCache.height =
              this.containers[b].element.outerHeight())
      return this
    },
    _createPlaceholder: function (a) {
      a = a || this
      var b,
        d = a.options
      if (!d.placeholder || d.placeholder.constructor === String)
        (b = d.placeholder),
          (d.placeholder = {
            element: function () {
              var d = a.currentItem[0].nodeName.toLowerCase(),
                f = c(a.document[0].createElement(d))
                  .addClass(
                    b || a.currentItem[0].className + ' ui-sortable-placeholder'
                  )
                  .removeClass('ui-sortable-helper')
              'tr' === d
                ? f.append("<td colspan='99'>&#160;</td>")
                : 'img' === d && f.attr('src', a.currentItem.attr('src'))
              b || f.css('visibility', 'hidden')
              return f
            },
            update: function (c, f) {
              if (!b || d.forcePlaceholderSize)
                f.height() ||
                  f.height(
                    a.currentItem.innerHeight() -
                      parseInt(a.currentItem.css('paddingTop') || 0, 10) -
                      parseInt(a.currentItem.css('paddingBottom') || 0, 10)
                  ),
                  f.width() ||
                    f.width(
                      a.currentItem.innerWidth() -
                        parseInt(a.currentItem.css('paddingLeft') || 0, 10) -
                        parseInt(a.currentItem.css('paddingRight') || 0, 10)
                    )
            },
          })
      a.placeholder = c(d.placeholder.element.call(a.element, a.currentItem))
      a.currentItem.after(a.placeholder)
      d.placeholder.update(a, a.placeholder)
    },
    _contactContainers: function (a) {
      var b,
        d,
        e,
        f,
        g,
        k,
        j,
        n,
        m,
        h = (d = null)
      for (b = this.containers.length - 1; 0 <= b; b--)
        if (!c.contains(this.currentItem[0], this.containers[b].element[0]))
          if (this._intersectsWith(this.containers[b].containerCache)) {
            if (!d || !c.contains(this.containers[b].element[0], d.element[0]))
              (d = this.containers[b]), (h = b)
          } else
            this.containers[b].containerCache.over &&
              (this.containers[b]._trigger('out', a, this._uiHash(this)),
              (this.containers[b].containerCache.over = 0))
      if (d)
        if (1 === this.containers.length)
          this.containers[h].containerCache.over ||
            (this.containers[h]._trigger('over', a, this._uiHash(this)),
            (this.containers[h].containerCache.over = 1))
        else {
          b = 1e4
          e = null
          f = (m = d.floating || l(this.currentItem)) ? 'left' : 'top'
          g = m ? 'width' : 'height'
          k = this.positionAbs[f] + this.offset.click[f]
          for (d = this.items.length - 1; 0 <= d; d--)
            if (
              c.contains(
                this.containers[h].element[0],
                this.items[d].item[0]
              ) &&
              this.items[d].item[0] !== this.currentItem[0] &&
              (!m ||
                (this.positionAbs.top + this.offset.click.top >
                  this.items[d].top &&
                  this.positionAbs.top + this.offset.click.top <
                    this.items[d].top + this.items[d].height))
            )
              (j = this.items[d].item.offset()[f]),
                (n = !1),
                Math.abs(j - k) > Math.abs(j + this.items[d][g] - k) &&
                  ((n = !0), (j += this.items[d][g])),
                Math.abs(j - k) < b &&
                  ((b = Math.abs(j - k)),
                  (e = this.items[d]),
                  (this.direction = n ? 'up' : 'down'))
          if (
            (e || this.options.dropOnEmpty) &&
            this.currentContainer !== this.containers[h]
          )
            e
              ? this._rearrange(a, e, null, !0)
              : this._rearrange(a, null, this.containers[h].element, !0),
              this._trigger('change', a, this._uiHash()),
              this.containers[h]._trigger('change', a, this._uiHash(this)),
              (this.currentContainer = this.containers[h]),
              this.options.placeholder.update(
                this.currentContainer,
                this.placeholder
              ),
              this.containers[h]._trigger('over', a, this._uiHash(this)),
              (this.containers[h].containerCache.over = 1)
        }
    },
    _createHelper: function (a) {
      var b = this.options
      a = c.isFunction(b.helper)
        ? c(b.helper.apply(this.element[0], [a, this.currentItem]))
        : 'clone' === b.helper
        ? this.currentItem.clone()
        : this.currentItem
      a.parents('body').length ||
        c(
          'parent' !== b.appendTo ? b.appendTo : this.currentItem[0].parentNode
        )[0].appendChild(a[0])
      a[0] === this.currentItem[0] &&
        (this._storedCSS = {
          width: this.currentItem[0].style.width,
          height: this.currentItem[0].style.height,
          position: this.currentItem.css('position'),
          top: this.currentItem.css('top'),
          left: this.currentItem.css('left'),
        })
      ;(!a[0].style.width || b.forceHelperSize) &&
        a.width(this.currentItem.width())
      ;(!a[0].style.height || b.forceHelperSize) &&
        a.height(this.currentItem.height())
      return a
    },
    _adjustOffsetFromHelper: function (a) {
      'string' === typeof a && (a = a.split(' '))
      c.isArray(a) && (a = { left: +a[0], top: +a[1] || 0 })
      'left' in a && (this.offset.click.left = a.left + this.margins.left)
      'right' in a &&
        (this.offset.click.left =
          this.helperProportions.width - a.right + this.margins.left)
      'top' in a && (this.offset.click.top = a.top + this.margins.top)
      'bottom' in a &&
        (this.offset.click.top =
          this.helperProportions.height - a.bottom + this.margins.top)
    },
    _getParentOffset: function () {
      this.offsetParent = this.helper.offsetParent()
      var a = this.offsetParent.offset()
      'absolute' === this.cssPosition &&
        this.scrollParent[0] !== document &&
        c.contains(this.scrollParent[0], this.offsetParent[0]) &&
        ((a.left += this.scrollParent.scrollLeft()),
        (a.top += this.scrollParent.scrollTop()))
      if (
        this.offsetParent[0] === document.body ||
        (this.offsetParent[0].tagName &&
          'html' === this.offsetParent[0].tagName.toLowerCase() &&
          c.ui.ie)
      )
        a = { top: 0, left: 0 }
      return {
        top:
          a.top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
        left:
          a.left +
          (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0),
      }
    },
    _getRelativeOffset: function () {
      if ('relative' === this.cssPosition) {
        var a = this.currentItem.position()
        return {
          top:
            a.top -
            (parseInt(this.helper.css('top'), 10) || 0) +
            this.scrollParent.scrollTop(),
          left:
            a.left -
            (parseInt(this.helper.css('left'), 10) || 0) +
            this.scrollParent.scrollLeft(),
        }
      }
      return { top: 0, left: 0 }
    },
    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.currentItem.css('marginLeft'), 10) || 0,
        top: parseInt(this.currentItem.css('marginTop'), 10) || 0,
      }
    },
    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight(),
      }
    },
    _setContainment: function () {
      var a, b, d
      b = this.options
      'parent' === b.containment && (b.containment = this.helper[0].parentNode)
      if ('document' === b.containment || 'window' === b.containment)
        this.containment = [
          0 - this.offset.relative.left - this.offset.parent.left,
          0 - this.offset.relative.top - this.offset.parent.top,
          c('document' === b.containment ? document : window).width() -
            this.helperProportions.width -
            this.margins.left,
          (c('document' === b.containment ? document : window).height() ||
            document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ]
      ;/^(document|window|parent)$/.test(b.containment) ||
        ((a = c(b.containment)[0]),
        (b = c(b.containment).offset()),
        (d = 'hidden' !== c(a).css('overflow')),
        (this.containment = [
          b.left +
            (parseInt(c(a).css('borderLeftWidth'), 10) || 0) +
            (parseInt(c(a).css('paddingLeft'), 10) || 0) -
            this.margins.left,
          b.top +
            (parseInt(c(a).css('borderTopWidth'), 10) || 0) +
            (parseInt(c(a).css('paddingTop'), 10) || 0) -
            this.margins.top,
          b.left +
            (d ? Math.max(a.scrollWidth, a.offsetWidth) : a.offsetWidth) -
            (parseInt(c(a).css('borderLeftWidth'), 10) || 0) -
            (parseInt(c(a).css('paddingRight'), 10) || 0) -
            this.helperProportions.width -
            this.margins.left,
          b.top +
            (d ? Math.max(a.scrollHeight, a.offsetHeight) : a.offsetHeight) -
            (parseInt(c(a).css('borderTopWidth'), 10) || 0) -
            (parseInt(c(a).css('paddingBottom'), 10) || 0) -
            this.helperProportions.height -
            this.margins.top,
        ]))
    },
    _convertPositionTo: function (a, b) {
      b || (b = this.position)
      var d = 'absolute' === a ? 1 : -1,
        e =
          'absolute' === this.cssPosition &&
          !(
            this.scrollParent[0] !== document &&
            c.contains(this.scrollParent[0], this.offsetParent[0])
          )
            ? this.offsetParent
            : this.scrollParent,
        f = /(html|body)/i.test(e[0].tagName)
      return {
        top:
          b.top +
          this.offset.relative.top * d +
          this.offset.parent.top * d -
          ('fixed' === this.cssPosition
            ? -this.scrollParent.scrollTop()
            : f
            ? 0
            : e.scrollTop()) *
            d,
        left:
          b.left +
          this.offset.relative.left * d +
          this.offset.parent.left * d -
          ('fixed' === this.cssPosition
            ? -this.scrollParent.scrollLeft()
            : f
            ? 0
            : e.scrollLeft()) *
            d,
      }
    },
    _generatePosition: function (a) {
      var b,
        d,
        e = this.options
      d = a.pageX
      b = a.pageY
      var f =
          'absolute' === this.cssPosition &&
          !(
            this.scrollParent[0] !== document &&
            c.contains(this.scrollParent[0], this.offsetParent[0])
          )
            ? this.offsetParent
            : this.scrollParent,
        g = /(html|body)/i.test(f[0].tagName)
      'relative' === this.cssPosition &&
        !(
          this.scrollParent[0] !== document &&
          this.scrollParent[0] !== this.offsetParent[0]
        ) &&
        (this.offset.relative = this._getRelativeOffset())
      this.originalPosition &&
        (this.containment &&
          (a.pageX - this.offset.click.left < this.containment[0] &&
            (d = this.containment[0] + this.offset.click.left),
          a.pageY - this.offset.click.top < this.containment[1] &&
            (b = this.containment[1] + this.offset.click.top),
          a.pageX - this.offset.click.left > this.containment[2] &&
            (d = this.containment[2] + this.offset.click.left),
          a.pageY - this.offset.click.top > this.containment[3] &&
            (b = this.containment[3] + this.offset.click.top)),
        e.grid &&
          ((b =
            this.originalPageY +
            Math.round((b - this.originalPageY) / e.grid[1]) * e.grid[1]),
          (b = this.containment
            ? b - this.offset.click.top >= this.containment[1] &&
              b - this.offset.click.top <= this.containment[3]
              ? b
              : b - this.offset.click.top >= this.containment[1]
              ? b - e.grid[1]
              : b + e.grid[1]
            : b),
          (d =
            this.originalPageX +
            Math.round((d - this.originalPageX) / e.grid[0]) * e.grid[0]),
          (d = this.containment
            ? d - this.offset.click.left >= this.containment[0] &&
              d - this.offset.click.left <= this.containment[2]
              ? d
              : d - this.offset.click.left >= this.containment[0]
              ? d - e.grid[0]
              : d + e.grid[0]
            : d)))
      return {
        top:
          b -
          this.offset.click.top -
          this.offset.relative.top -
          this.offset.parent.top +
          ('fixed' === this.cssPosition
            ? -this.scrollParent.scrollTop()
            : g
            ? 0
            : f.scrollTop()),
        left:
          d -
          this.offset.click.left -
          this.offset.relative.left -
          this.offset.parent.left +
          ('fixed' === this.cssPosition
            ? -this.scrollParent.scrollLeft()
            : g
            ? 0
            : f.scrollLeft()),
      }
    },
    _rearrange: function (a, b, d, c) {
      d
        ? d[0].appendChild(this.placeholder[0])
        : b.item[0].parentNode.insertBefore(
            this.placeholder[0],
            'down' === this.direction ? b.item[0] : b.item[0].nextSibling
          )
      var f = (this.counter = this.counter ? ++this.counter : 1)
      this._delay(function () {
        f === this.counter && this.refreshPositions(!c)
      })
    },
    _clear: function (a, b) {
      this.reverting = !1
      var d,
        c = []
      !this._noFinalSort &&
        this.currentItem.parent().length &&
        this.placeholder.before(this.currentItem)
      this._noFinalSort = null
      if (this.helper[0] === this.currentItem[0]) {
        for (d in this._storedCSS)
          if ('auto' === this._storedCSS[d] || 'static' === this._storedCSS[d])
            this._storedCSS[d] = ''
        this.currentItem.css(this._storedCSS).removeClass('ui-sortable-helper')
      } else this.currentItem.show()
      this.fromOutside &&
        !b &&
        c.push(function (a) {
          this._trigger('receive', a, this._uiHash(this.fromOutside))
        })
      ;(this.fromOutside ||
        this.domPosition.prev !==
          this.currentItem.prev().not('.ui-sortable-helper')[0] ||
        this.domPosition.parent !== this.currentItem.parent()[0]) &&
        !b &&
        c.push(function (a) {
          this._trigger('update', a, this._uiHash())
        })
      this !== this.currentContainer &&
        !b &&
        (c.push(function (a) {
          this._trigger('remove', a, this._uiHash())
        }),
        c.push(
          function (a) {
            return function (b) {
              a._trigger('receive', b, this._uiHash(this))
            }
          }.call(this, this.currentContainer)
        ),
        c.push(
          function (a) {
            return function (b) {
              a._trigger('update', b, this._uiHash(this))
            }
          }.call(this, this.currentContainer)
        ))
      for (d = this.containers.length - 1; 0 <= d; d--)
        b ||
          c.push(
            function (a) {
              return function (b) {
                a._trigger('deactivate', b, this._uiHash(this))
              }
            }.call(this, this.containers[d])
          ),
          this.containers[d].containerCache.over &&
            (c.push(
              function (a) {
                return function (b) {
                  a._trigger('out', b, this._uiHash(this))
                }
              }.call(this, this.containers[d])
            ),
            (this.containers[d].containerCache.over = 0))
      this.storedCursor &&
        (this.document.find('body').css('cursor', this.storedCursor),
        this.storedStylesheet.remove())
      this._storedOpacity && this.helper.css('opacity', this._storedOpacity)
      this._storedZIndex &&
        this.helper.css(
          'zIndex',
          'auto' === this._storedZIndex ? '' : this._storedZIndex
        )
      this.dragging = !1
      if (this.cancelHelperRemoval) {
        if (!b) {
          this._trigger('beforeStop', a, this._uiHash())
          for (d = 0; d < c.length; d++) c[d].call(this, a)
          this._trigger('stop', a, this._uiHash())
        }
        return (this.fromOutside = !1)
      }
      b || this._trigger('beforeStop', a, this._uiHash())
      this.placeholder[0].parentNode.removeChild(this.placeholder[0])
      this.helper[0] !== this.currentItem[0] && this.helper.remove()
      this.helper = null
      if (!b) {
        for (d = 0; d < c.length; d++) c[d].call(this, a)
        this._trigger('stop', a, this._uiHash())
      }
      this.fromOutside = !1
      return !0
    },
    _trigger: function () {
      !1 === c.Widget.prototype._trigger.apply(this, arguments) && this.cancel()
    },
    _uiHash: function (a) {
      var b = a || this
      return {
        helper: b.helper,
        placeholder: b.placeholder || c([]),
        position: b.position,
        originalPosition: b.originalPosition,
        offset: b.positionAbs,
        item: b.currentItem,
        sender: a ? a.element : null,
      }
    },
  })
})(jQuery)

/*!
 * jQuery UI Draggable 1.10.2
 * http://jqueryui.com
 *
 * Copyright 2013 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
;(function ($, undefined) {
  $.widget('ui.draggable', $.ui.mouse, {
    version: '1.10.2',
    widgetEventPrefix: 'drag',
    options: {
      addClasses: true,
      appendTo: 'parent',
      axis: false,
      connectToSortable: false,
      containment: false,
      cursor: 'auto',
      cursorAt: false,
      grid: false,
      handle: false,
      helper: 'original',
      iframeFix: false,
      opacity: false,
      refreshPositions: false,
      revert: false,
      revertDuration: 500,
      scope: 'default',
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      snap: false,
      snapMode: 'both',
      snapTolerance: 20,
      stack: false,
      zIndex: false,

      // callbacks
      drag: null,
      start: null,
      stop: null,
    },
    _create: function () {
      if (
        this.options.helper === 'original' &&
        !/^(?:r|a|f)/.test(this.element.css('position'))
      ) {
        this.element[0].style.position = 'relative'
      }
      if (this.options.addClasses) {
        this.element.addClass('ui-draggable')
      }
      if (this.options.disabled) {
        this.element.addClass('ui-draggable-disabled')
      }

      this._mouseInit()
    },

    _destroy: function () {
      this.element.removeClass(
        'ui-draggable ui-draggable-dragging ui-draggable-disabled'
      )
      this._mouseDestroy()
    },

    _mouseCapture: function (event) {
      var o = this.options

      // among others, prevent a drag on a resizable-handle
      if (
        this.helper ||
        o.disabled ||
        $(event.target).closest('.ui-resizable-handle').length > 0
      ) {
        return false
      }

      //Quit if we're not on a valid handle
      this.handle = this._getHandle(event)
      if (!this.handle) {
        return false
      }

      $(o.iframeFix === true ? 'iframe' : o.iframeFix).each(function () {
        $(
          "<div class='ui-draggable-iframeFix' style='background: #fff;'></div>"
        )
          .css({
            width: this.offsetWidth + 'px',
            height: this.offsetHeight + 'px',
            position: 'absolute',
            opacity: '0.001',
            zIndex: 1000,
          })
          .css($(this).offset())
          .appendTo('body')
      })

      return true
    },

    _mouseStart: function (event) {
      var o = this.options

      //Create and append the visible helper
      this.helper = this._createHelper(event)

      this.helper.addClass('ui-draggable-dragging')

      //Cache the helper size
      this._cacheHelperProportions()

      //If ddmanager is used for droppables, set the global draggable
      if ($.ui.ddmanager) {
        $.ui.ddmanager.current = this
      }

      /*
       * - Position generation -
       * This block generates everything position related - it's the core of draggables.
       */

      //Cache the margins of the original element
      this._cacheMargins()

      //Store the helper's css position
      this.cssPosition = this.helper.css('position')
      this.scrollParent = this.helper.scrollParent()

      //The element's absolute position on the page minus margins
      this.offset = this.positionAbs = this.element.offset()
      this.offset = {
        top: this.offset.top - this.margins.top,
        left: this.offset.left - this.margins.left,
      }

      $.extend(this.offset, {
        click: {
          //Where the click happened, relative to the element
          left: event.pageX - this.offset.left,
          top: event.pageY - this.offset.top,
        },
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset(), //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
      })

      //Generate the original position
      this.originalPosition = this.position = this._generatePosition(event)
      this.originalPageX = event.pageX
      this.originalPageY = event.pageY

      //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
      o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt)

      //Set a containment if given in the options
      if (o.containment) {
        this._setContainment()
      }

      //Trigger event + callbacks
      if (this._trigger('start', event) === false) {
        this._clear()
        return false
      }

      //Recache the helper size
      this._cacheHelperProportions()

      //Prepare the droppable offsets
      if ($.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(this, event)
      }

      this._mouseDrag(event, true) //Execute the drag once - this causes the helper not to be visible before getting its correct position

      //If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
      if ($.ui.ddmanager) {
        $.ui.ddmanager.dragStart(this, event)
      }

      return true
    },

    _mouseDrag: function (event, noPropagation) {
      //Compute the helpers position
      this.position = this._generatePosition(event)
      this.positionAbs = this._convertPositionTo('absolute')

      //Call plugins and callbacks and use the resulting position if something is returned
      if (!noPropagation) {
        var ui = this._uiHash()
        if (this._trigger('drag', event, ui) === false) {
          this._mouseUp({})
          return false
        }
        this.position = ui.position
      }

      if (!this.options.axis || this.options.axis !== 'y') {
        this.helper[0].style.left = this.position.left + 'px'
      }
      if (!this.options.axis || this.options.axis !== 'x') {
        this.helper[0].style.top = this.position.top + 'px'
      }
      if ($.ui.ddmanager) {
        $.ui.ddmanager.drag(this, event)
      }

      return false
    },

    _mouseStop: function (event) {
      //If we are using droppables, inform the manager about the drop
      var element,
        that = this,
        elementInDom = false,
        dropped = false
      if ($.ui.ddmanager && !this.options.dropBehaviour) {
        dropped = $.ui.ddmanager.drop(this, event)
      }

      //if a drop comes from outside (a sortable)
      if (this.dropped) {
        dropped = this.dropped
        this.dropped = false
      }

      //if the original element is no longer in the DOM don't bother to continue (see #8269)
      element = this.element[0]
      while (element && (element = element.parentNode)) {
        if (element === document) {
          elementInDom = true
        }
      }
      if (!elementInDom && this.options.helper === 'original') {
        return false
      }

      if (
        (this.options.revert === 'invalid' && !dropped) ||
        (this.options.revert === 'valid' && dropped) ||
        this.options.revert === true ||
        ($.isFunction(this.options.revert) &&
          this.options.revert.call(this.element, dropped))
      ) {
        $(this.helper).animate(
          this.originalPosition,
          parseInt(this.options.revertDuration, 10),
          function () {
            if (that._trigger('stop', event) !== false) {
              that._clear()
            }
          }
        )
      } else {
        if (this._trigger('stop', event) !== false) {
          this._clear()
        }
      }

      return false
    },

    _mouseUp: function (event) {
      //Remove frame helpers
      $('div.ui-draggable-iframeFix').each(function () {
        this.parentNode.removeChild(this)
      })

      //If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
      if ($.ui.ddmanager) {
        $.ui.ddmanager.dragStop(this, event)
      }

      return $.ui.mouse.prototype._mouseUp.call(this, event)
    },

    cancel: function () {
      if (this.helper.is('.ui-draggable-dragging')) {
        this._mouseUp({})
      } else {
        this._clear()
      }

      return this
    },

    _getHandle: function (event) {
      return this.options.handle
        ? !!$(event.target).closest(this.element.find(this.options.handle))
            .length
        : true
    },

    _createHelper: function (event) {
      var o = this.options,
        helper = $.isFunction(o.helper)
          ? $(o.helper.apply(this.element[0], [event]))
          : o.helper === 'clone'
          ? this.element.clone().removeAttr('id')
          : this.element

      if (!helper.parents('body').length) {
        helper.appendTo(
          o.appendTo === 'parent' ? this.element[0].parentNode : o.appendTo
        )
      }

      if (
        helper[0] !== this.element[0] &&
        !/(fixed|absolute)/.test(helper.css('position'))
      ) {
        helper.css('position', 'absolute')
      }

      return helper
    },

    _adjustOffsetFromHelper: function (obj) {
      if (typeof obj === 'string') {
        obj = obj.split(' ')
      }
      if ($.isArray(obj)) {
        obj = { left: +obj[0], top: +obj[1] || 0 }
      }
      if ('left' in obj) {
        this.offset.click.left = obj.left + this.margins.left
      }
      if ('right' in obj) {
        this.offset.click.left =
          this.helperProportions.width - obj.right + this.margins.left
      }
      if ('top' in obj) {
        this.offset.click.top = obj.top + this.margins.top
      }
      if ('bottom' in obj) {
        this.offset.click.top =
          this.helperProportions.height - obj.bottom + this.margins.top
      }
    },

    _getParentOffset: function () {
      //Get the offsetParent and cache its position
      this.offsetParent = this.helper.offsetParent()
      var po = this.offsetParent.offset()

      // This is a special case where we need to modify a offset calculated on start, since the following happened:
      // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
      // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
      //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
      if (
        this.cssPosition === 'absolute' &&
        this.scrollParent[0] !== document &&
        $.contains(this.scrollParent[0], this.offsetParent[0])
      ) {
        po.left += this.scrollParent.scrollLeft()
        po.top += this.scrollParent.scrollTop()
      }

      //This needs to be actually done for all browsers, since pageX/pageY includes this information
      //Ugly IE fix
      if (
        this.offsetParent[0] === document.body ||
        (this.offsetParent[0].tagName &&
          this.offsetParent[0].tagName.toLowerCase() === 'html' &&
          $.ui.ie)
      ) {
        po = { top: 0, left: 0 }
      }

      return {
        top:
          po.top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
        left:
          po.left +
          (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0),
      }
    },

    _getRelativeOffset: function () {
      if (this.cssPosition === 'relative') {
        var p = this.element.position()
        return {
          top:
            p.top -
            (parseInt(this.helper.css('top'), 10) || 0) +
            this.scrollParent.scrollTop(),
          left:
            p.left -
            (parseInt(this.helper.css('left'), 10) || 0) +
            this.scrollParent.scrollLeft(),
        }
      } else {
        return { top: 0, left: 0 }
      }
    },

    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.element.css('marginLeft'), 10) || 0,
        top: parseInt(this.element.css('marginTop'), 10) || 0,
        right: parseInt(this.element.css('marginRight'), 10) || 0,
        bottom: parseInt(this.element.css('marginBottom'), 10) || 0,
      }
    },

    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight(),
      }
    },

    _setContainment: function () {
      var over,
        c,
        ce,
        o = this.options

      if (o.containment === 'parent') {
        o.containment = this.helper[0].parentNode
      }
      if (o.containment === 'document' || o.containment === 'window') {
        this.containment = [
          o.containment === 'document'
            ? 0
            : $(window).scrollLeft() -
              this.offset.relative.left -
              this.offset.parent.left,
          o.containment === 'document'
            ? 0
            : $(window).scrollTop() -
              this.offset.relative.top -
              this.offset.parent.top,
          (o.containment === 'document' ? 0 : $(window).scrollLeft()) +
            $(o.containment === 'document' ? document : window).width() -
            this.helperProportions.width -
            this.margins.left,
          (o.containment === 'document' ? 0 : $(window).scrollTop()) +
            ($(o.containment === 'document' ? document : window).height() ||
              document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ]
      }

      if (
        !/^(document|window|parent)$/.test(o.containment) &&
        o.containment.constructor !== Array
      ) {
        c = $(o.containment)
        ce = c[0]

        if (!ce) {
          return
        }

        over = $(ce).css('overflow') !== 'hidden'

        this.containment = [
          (parseInt($(ce).css('borderLeftWidth'), 10) || 0) +
            (parseInt($(ce).css('paddingLeft'), 10) || 0),
          (parseInt($(ce).css('borderTopWidth'), 10) || 0) +
            (parseInt($(ce).css('paddingTop'), 10) || 0),
          (over ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) -
            (parseInt($(ce).css('borderRightWidth'), 10) || 0) -
            (parseInt($(ce).css('paddingRight'), 10) || 0) -
            this.helperProportions.width -
            this.margins.left -
            this.margins.right,
          (over
            ? Math.max(ce.scrollHeight, ce.offsetHeight)
            : ce.offsetHeight) -
            (parseInt($(ce).css('borderBottomWidth'), 10) || 0) -
            (parseInt($(ce).css('paddingBottom'), 10) || 0) -
            this.helperProportions.height -
            this.margins.top -
            this.margins.bottom,
        ]
        this.relative_container = c
      } else if (o.containment.constructor === Array) {
        this.containment = o.containment
      }
    },

    _convertPositionTo: function (d, pos) {
      if (!pos) {
        pos = this.position
      }

      var mod = d === 'absolute' ? 1 : -1,
        scroll =
          this.cssPosition === 'absolute' &&
          !(
            this.scrollParent[0] !== document &&
            $.contains(this.scrollParent[0], this.offsetParent[0])
          )
            ? this.offsetParent
            : this.scrollParent,
        scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName)

      return {
        top:
          pos.top + // The absolute mouse position
          this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollTop()
            : scrollIsRootNode
            ? 0
            : scroll.scrollTop()) *
            mod,
        left:
          pos.left + // The absolute mouse position
          this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollLeft()
            : scrollIsRootNode
            ? 0
            : scroll.scrollLeft()) *
            mod,
      }
    },

    _generatePosition: function (event) {
      var containment,
        co,
        top,
        left,
        o = this.options,
        scroll =
          this.cssPosition === 'absolute' &&
          !(
            this.scrollParent[0] !== document &&
            $.contains(this.scrollParent[0], this.offsetParent[0])
          )
            ? this.offsetParent
            : this.scrollParent,
        scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName),
        pageX = event.pageX,
        pageY = event.pageY

      /*
       * - Position constraining -
       * Constrain the position to a mix of grid, containment.
       */

      if (this.originalPosition) {
        //If we are not dragging yet, we won't check for options
        if (this.containment) {
          if (this.relative_container) {
            co = this.relative_container.offset()
            containment = [
              this.containment[0] + co.left,
              this.containment[1] + co.top,
              this.containment[2] + co.left,
              this.containment[3] + co.top,
            ]
          } else {
            containment = this.containment
          }

          if (event.pageX - this.offset.click.left < containment[0]) {
            pageX = containment[0] + this.offset.click.left
          }
          if (event.pageY - this.offset.click.top < containment[1]) {
            pageY = containment[1] + this.offset.click.top
          }
          if (event.pageX - this.offset.click.left > containment[2]) {
            pageX = containment[2] + this.offset.click.left
          }
          if (event.pageY - this.offset.click.top > containment[3]) {
            pageY = containment[3] + this.offset.click.top
          }
        }

        if (o.grid) {
          //Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
          top = o.grid[1]
            ? this.originalPageY +
              Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1]
            : this.originalPageY
          pageY = containment
            ? top - this.offset.click.top >= containment[1] ||
              top - this.offset.click.top > containment[3]
              ? top
              : top - this.offset.click.top >= containment[1]
              ? top - o.grid[1]
              : top + o.grid[1]
            : top

          left = o.grid[0]
            ? this.originalPageX +
              Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0]
            : this.originalPageX
          pageX = containment
            ? left - this.offset.click.left >= containment[0] ||
              left - this.offset.click.left > containment[2]
              ? left
              : left - this.offset.click.left >= containment[0]
              ? left - o.grid[0]
              : left + o.grid[0]
            : left
        }
      }

      return {
        top:
          pageY - // The absolute mouse position
          this.offset.click.top - // Click offset (relative to the element)
          this.offset.relative.top - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollTop()
            : scrollIsRootNode
            ? 0
            : scroll.scrollTop()),
        left:
          pageX - // The absolute mouse position
          this.offset.click.left - // Click offset (relative to the element)
          this.offset.relative.left - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === 'fixed'
            ? -this.scrollParent.scrollLeft()
            : scrollIsRootNode
            ? 0
            : scroll.scrollLeft()),
      }
    },

    _clear: function () {
      this.helper.removeClass('ui-draggable-dragging')
      if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
        this.helper.remove()
      }
      this.helper = null
      this.cancelHelperRemoval = false
    },

    // From now on bulk stuff - mainly helpers

    _trigger: function (type, event, ui) {
      ui = ui || this._uiHash()
      $.ui.plugin.call(this, type, [event, ui])
      //The absolute position has to be recalculated after plugins
      if (type === 'drag') {
        this.positionAbs = this._convertPositionTo('absolute')
      }
      return $.Widget.prototype._trigger.call(this, type, event, ui)
    },

    plugins: {},

    _uiHash: function () {
      return {
        helper: this.helper,
        position: this.position,
        originalPosition: this.originalPosition,
        offset: this.positionAbs,
      }
    },
  })

  $.ui.plugin.add('draggable', 'connectToSortable', {
    start: function (event, ui) {
      var inst = $(this).data('ui-draggable'),
        o = inst.options,
        uiSortable = $.extend({}, ui, { item: inst.element })
      inst.sortables = []
      $(o.connectToSortable).each(function () {
        var sortable = $.data(this, 'ui-sortable')
        if (sortable && !sortable.options.disabled) {
          inst.sortables.push({
            instance: sortable,
            shouldRevert: sortable.options.revert,
          })
          sortable.refreshPositions() // Call the sortable's refreshPositions at drag start to refresh the containerCache since the sortable container cache is used in drag and needs to be up to date (this will ensure it's initialised as well as being kept in step with any changes that might have happened on the page).
          sortable._trigger('activate', event, uiSortable)
        }
      })
    },
    stop: function (event, ui) {
      //If we are still over the sortable, we fake the stop event of the sortable, but also remove helper
      var inst = $(this).data('ui-draggable'),
        uiSortable = $.extend({}, ui, { item: inst.element })

      $.each(inst.sortables, function () {
        if (this.instance.isOver) {
          this.instance.isOver = 0

          inst.cancelHelperRemoval = true //Don't remove the helper in the draggable instance
          this.instance.cancelHelperRemoval = false //Remove it in the sortable instance (so sortable plugins like revert still work)

          //The sortable revert is supported, and we have to set a temporary dropped variable on the draggable to support revert: "valid/invalid"
          if (this.shouldRevert) {
            this.instance.options.revert = this.shouldRevert
          }

          //Trigger the stop of the sortable
          this.instance._mouseStop(event)

          this.instance.options.helper = this.instance.options._helper

          //If the helper has been the original item, restore properties in the sortable
          if (inst.options.helper === 'original') {
            this.instance.currentItem.css({ top: 'auto', left: 'auto' })
          }
        } else {
          this.instance.cancelHelperRemoval = false //Remove the helper in the sortable instance
          this.instance._trigger('deactivate', event, uiSortable)
        }
      })
    },
    drag: function (event, ui) {
      var inst = $(this).data('ui-draggable'),
        that = this

      $.each(inst.sortables, function () {
        var innermostIntersecting = false,
          thisSortable = this

        //Copy over some variables to allow calling the sortable's native _intersectsWith
        this.instance.positionAbs = inst.positionAbs
        this.instance.helperProportions = inst.helperProportions
        this.instance.offset.click = inst.offset.click

        if (this.instance._intersectsWith(this.instance.containerCache)) {
          innermostIntersecting = true
          $.each(inst.sortables, function () {
            this.instance.positionAbs = inst.positionAbs
            this.instance.helperProportions = inst.helperProportions
            this.instance.offset.click = inst.offset.click
            if (
              this !== thisSortable &&
              this.instance._intersectsWith(this.instance.containerCache) &&
              $.contains(
                thisSortable.instance.element[0],
                this.instance.element[0]
              )
            ) {
              innermostIntersecting = false
            }
            return innermostIntersecting
          })
        }

        if (innermostIntersecting) {
          //If it intersects, we use a little isOver variable and set it once, so our move-in stuff gets fired only once
          if (!this.instance.isOver) {
            this.instance.isOver = 1
            //Now we fake the start of dragging for the sortable instance,
            //by cloning the list group item, appending it to the sortable and using it as inst.currentItem
            //We can then fire the start event of the sortable with our passed browser event, and our own helper (so it doesn't create a new one)
            this.instance.currentItem = $(that)
              .clone()
              .removeAttr('id')
              .appendTo(this.instance.element)
              .data('ui-sortable-item', true)
            this.instance.options._helper = this.instance.options.helper //Store helper option to later restore it
            this.instance.options.helper = function () {
              return ui.helper[0]
            }

            event.target = this.instance.currentItem[0]
            this.instance._mouseCapture(event, true)
            this.instance._mouseStart(event, true, true)

            //Because the browser event is way off the new appended portlet, we modify a couple of variables to reflect the changes
            this.instance.offset.click.top = inst.offset.click.top
            this.instance.offset.click.left = inst.offset.click.left
            this.instance.offset.parent.left -=
              inst.offset.parent.left - this.instance.offset.parent.left
            this.instance.offset.parent.top -=
              inst.offset.parent.top - this.instance.offset.parent.top

            inst._trigger('toSortable', event)
            inst.dropped = this.instance.element //draggable revert needs that
            //hack so receive/update callbacks work (mostly)
            inst.currentItem = inst.element
            this.instance.fromOutside = inst
          }

          //Provided we did all the previous steps, we can fire the drag event of the sortable on every draggable drag, when it intersects with the sortable
          if (this.instance.currentItem) {
            this.instance._mouseDrag(event)
          }
        } else {
          //If it doesn't intersect with the sortable, and it intersected before,
          //we fake the drag stop of the sortable, but make sure it doesn't remove the helper by using cancelHelperRemoval
          if (this.instance.isOver) {
            this.instance.isOver = 0
            this.instance.cancelHelperRemoval = true

            //Prevent reverting on this forced stop
            this.instance.options.revert = false

            // The out event needs to be triggered independently
            this.instance._trigger(
              'out',
              event,
              this.instance._uiHash(this.instance)
            )

            this.instance._mouseStop(event, true)
            this.instance.options.helper = this.instance.options._helper

            //Now we remove our currentItem, the list group clone again, and the placeholder, and animate the helper back to it's original size
            this.instance.currentItem.remove()
            if (this.instance.placeholder) {
              this.instance.placeholder.remove()
            }

            inst._trigger('fromSortable', event)
            inst.dropped = false //draggable revert needs that
          }
        }
      })
    },
  })

  $.ui.plugin.add('draggable', 'cursor', {
    start: function () {
      var t = $('body'),
        o = $(this).data('ui-draggable').options
      if (t.css('cursor')) {
        o._cursor = t.css('cursor')
      }
      t.css('cursor', o.cursor)
    },
    stop: function () {
      var o = $(this).data('ui-draggable').options
      if (o._cursor) {
        $('body').css('cursor', o._cursor)
      }
    },
  })

  $.ui.plugin.add('draggable', 'opacity', {
    start: function (event, ui) {
      var t = $(ui.helper),
        o = $(this).data('ui-draggable').options
      if (t.css('opacity')) {
        o._opacity = t.css('opacity')
      }
      t.css('opacity', o.opacity)
    },
    stop: function (event, ui) {
      var o = $(this).data('ui-draggable').options
      if (o._opacity) {
        $(ui.helper).css('opacity', o._opacity)
      }
    },
  })

  $.ui.plugin.add('draggable', 'scroll', {
    start: function () {
      var i = $(this).data('ui-draggable')
      if (
        i.scrollParent[0] !== document &&
        i.scrollParent[0].tagName !== 'HTML'
      ) {
        i.overflowOffset = i.scrollParent.offset()
      }
    },
    drag: function (event) {
      var i = $(this).data('ui-draggable'),
        o = i.options,
        scrolled = false

      if (
        i.scrollParent[0] !== document &&
        i.scrollParent[0].tagName !== 'HTML'
      ) {
        if (!o.axis || o.axis !== 'x') {
          if (
            i.overflowOffset.top +
              i.scrollParent[0].offsetHeight -
              event.pageY <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollTop = scrolled =
              i.scrollParent[0].scrollTop + o.scrollSpeed
          } else if (event.pageY - i.overflowOffset.top < o.scrollSensitivity) {
            i.scrollParent[0].scrollTop = scrolled =
              i.scrollParent[0].scrollTop - o.scrollSpeed
          }
        }

        if (!o.axis || o.axis !== 'y') {
          if (
            i.overflowOffset.left +
              i.scrollParent[0].offsetWidth -
              event.pageX <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollLeft = scrolled =
              i.scrollParent[0].scrollLeft + o.scrollSpeed
          } else if (
            event.pageX - i.overflowOffset.left <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollLeft = scrolled =
              i.scrollParent[0].scrollLeft - o.scrollSpeed
          }
        }
      } else {
        if (!o.axis || o.axis !== 'x') {
          if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() - o.scrollSpeed
            )
          } else if (
            $(window).height() - (event.pageY - $(document).scrollTop()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() + o.scrollSpeed
            )
          }
        }

        if (!o.axis || o.axis !== 'y') {
          if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() - o.scrollSpeed
            )
          } else if (
            $(window).width() - (event.pageX - $(document).scrollLeft()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() + o.scrollSpeed
            )
          }
        }
      }

      if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(i, event)
      }
    },
  })

  $.ui.plugin.add('draggable', 'snap', {
    start: function () {
      var i = $(this).data('ui-draggable'),
        o = i.options

      i.snapElements = []

      $(
        o.snap.constructor !== String
          ? o.snap.items || ':data(ui-draggable)'
          : o.snap
      ).each(function () {
        var $t = $(this),
          $o = $t.offset()
        if (this !== i.element[0]) {
          i.snapElements.push({
            item: this,
            width: $t.outerWidth(),
            height: $t.outerHeight(),
            top: $o.top,
            left: $o.left,
          })
        }
      })
    },
    drag: function (event, ui) {
      var ts,
        bs,
        ls,
        rs,
        l,
        r,
        t,
        b,
        i,
        first,
        inst = $(this).data('ui-draggable'),
        o = inst.options,
        d = o.snapTolerance,
        x1 = ui.offset.left,
        x2 = x1 + inst.helperProportions.width,
        y1 = ui.offset.top,
        y2 = y1 + inst.helperProportions.height

      for (i = inst.snapElements.length - 1; i >= 0; i--) {
        l = inst.snapElements[i].left
        r = l + inst.snapElements[i].width
        t = inst.snapElements[i].top
        b = t + inst.snapElements[i].height

        //Yes, I know, this is insane ;)
        if (
          !(
            (l - d < x1 && x1 < r + d && t - d < y1 && y1 < b + d) ||
            (l - d < x1 && x1 < r + d && t - d < y2 && y2 < b + d) ||
            (l - d < x2 && x2 < r + d && t - d < y1 && y1 < b + d) ||
            (l - d < x2 && x2 < r + d && t - d < y2 && y2 < b + d)
          )
        ) {
          if (inst.snapElements[i].snapping) {
            inst.options.snap.release &&
              inst.options.snap.release.call(
                inst.element,
                event,
                $.extend(inst._uiHash(), {
                  snapItem: inst.snapElements[i].item,
                })
              )
          }
          inst.snapElements[i].snapping = false
          continue
        }

        if (o.snapMode !== 'inner') {
          ts = Math.abs(t - y2) <= d
          bs = Math.abs(b - y1) <= d
          ls = Math.abs(l - x2) <= d
          rs = Math.abs(r - x1) <= d
          if (ts) {
            ui.position.top =
              inst._convertPositionTo('relative', {
                top: t - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top
          }
          if (bs) {
            ui.position.top =
              inst._convertPositionTo('relative', { top: b, left: 0 }).top -
              inst.margins.top
          }
          if (ls) {
            ui.position.left =
              inst._convertPositionTo('relative', {
                top: 0,
                left: l - inst.helperProportions.width,
              }).left - inst.margins.left
          }
          if (rs) {
            ui.position.left =
              inst._convertPositionTo('relative', { top: 0, left: r }).left -
              inst.margins.left
          }
        }

        first = ts || bs || ls || rs

        if (o.snapMode !== 'outer') {
          ts = Math.abs(t - y1) <= d
          bs = Math.abs(b - y2) <= d
          ls = Math.abs(l - x1) <= d
          rs = Math.abs(r - x2) <= d
          if (ts) {
            ui.position.top =
              inst._convertPositionTo('relative', { top: t, left: 0 }).top -
              inst.margins.top
          }
          if (bs) {
            ui.position.top =
              inst._convertPositionTo('relative', {
                top: b - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top
          }
          if (ls) {
            ui.position.left =
              inst._convertPositionTo('relative', { top: 0, left: l }).left -
              inst.margins.left
          }
          if (rs) {
            ui.position.left =
              inst._convertPositionTo('relative', {
                top: 0,
                left: r - inst.helperProportions.width,
              }).left - inst.margins.left
          }
        }

        if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
          inst.options.snap.snap &&
            inst.options.snap.snap.call(
              inst.element,
              event,
              $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })
            )
        }
        inst.snapElements[i].snapping = ts || bs || ls || rs || first
      }
    },
  })

  $.ui.plugin.add('draggable', 'stack', {
    start: function () {
      var min,
        o = this.data('ui-draggable').options,
        group = $.makeArray($(o.stack)).sort(function (a, b) {
          return (
            (parseInt($(a).css('zIndex'), 10) || 0) -
            (parseInt($(b).css('zIndex'), 10) || 0)
          )
        })

      if (!group.length) {
        return
      }

      min = parseInt($(group[0]).css('zIndex'), 10) || 0
      $(group).each(function (i) {
        $(this).css('zIndex', min + i)
      })
      this.css('zIndex', min + group.length)
    },
  })

  $.ui.plugin.add('draggable', 'zIndex', {
    start: function (event, ui) {
      var t = $(ui.helper),
        o = $(this).data('ui-draggable').options
      if (t.css('zIndex')) {
        o._zIndex = t.css('zIndex')
      }
      t.css('zIndex', o.zIndex)
    },
    stop: function (event, ui) {
      var o = $(this).data('ui-draggable').options
      if (o._zIndex) {
        $(ui.helper).css('zIndex', o._zIndex)
      }
    },
  })
})(jQuery)
